import Vue from 'vue';
import axios from 'axios';
import JsonExcel from "vue-json-excel";
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

Vue.component("downloadExcel", JsonExcel);

export default {
  name: 'queryViewer',
  components: {
    datetime: Datetime,
    DateTime,
  },
  data: function () {
    return {
      queryId: -1,
      queryParams: [],
      queryResult: [],
      queryColumns: [],
      queryExecuted: false,
    }
  },
  created() {
    this.queryId = this.$route.params.id;
    this.getQueryParameters();
  },
  methods: {
    getQueryParameters() {
      axios.get('/CustomQuery/GetQueryParameters?queryId=' + this.queryId)
        .then(response => {
          if (response.status == 200) {
            this.queryParams = response.data.parameters;

            console.log(this.queryParams);

            if (this.queryParams.length == 0)
              this.executeQuery();
          }
        })
        .catch(err => {
          err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$alertMsg(err.data.data.text)
        })
    },
    executeQuery() {
      const parameters = {
        QueryId: this.queryId,
        QueryParameters: this.queryParams
      };

      axios.post('/CustomQuery/ExecuteQuery', parameters)
        .then(response => {
          if (response.status == 200) {
            this.queryExecuted = true;
            this.queryResult = response.data.dataTable;

            this.queryColumns = [];

            if (this.queryResult.length > 0) {
              console.log(this.queryResult[0]);
              console.log(Object.keys(this.queryResult[0]));
              this.queryColumns = Object.keys(this.queryResult[0]);
              console.log(this.queryColumns);
            }
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data)
        })
    }
  },
}

